
export default {
  name: "the-password",
  components: {

  },
  props: {
    description: {},
    title: {},
    requireValidation: {
      default: true,
      type: Boolean,
      required: false
    },
    error: {
      required: false,
      default: '',
      type: String
    },
    layout: {
      required: false,
      default: 'chain',
      type: String
    }
  },
  data() {
    return {
      password: '',
      passwordVisible: false,
      validated: false,
      rules: {
        required: value => !!value || 'Dette feltet er obligatorisk.',
        password: value => {
          const pattern = /^(?=.*\d)(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/
          return pattern.test(value) || 'Passord må inneholde minimum 8 tegn, minst ett tall og en stor bokstav.'
        },
      },
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
      this.$emit("setValue", value);
    },
    validate() {
      return this.validated
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.passwordInput.$refs.input.focus()
      })
    })
  }
}
